import React, { Suspense, useEffect, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Loading from "./global/Loading";
import "./App.css";
import ToastContainer from "./components/Toast";
import { publicRoutes } from "./routes/publicRoutes";
import { privateRoutes } from "./routes/privateRoutes";
import Cookies from "js-cookie";

function App() {
  const [isAuthenticated, setIsAuthentication] = useState(() =>
    Cookies.get("token")
  );

  useEffect(() => {
    if (!isAuthenticated)
      setIsAuthentication(Cookies.set("redirectedPath", window.location.href));
  }, [isAuthenticated]);

  return (
    <div
      className="h-full no-scrollbar overflow-x-hidden font-IranSans md:overflow-y-scroll no-scrollbar absolute top-0 right-0 w-screen"
      id="appId"
    >
      <Suspense fallback={<Loading />}>
        <Routes>
          {publicRoutes.map((route, index) => (
            <Route key={index} path={route.path} element={route.element} />
          ))}

          {privateRoutes.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={
                !isAuthenticated ? (
                  <Navigate replace={true} to="/login" />
                ) : (
                  route.element
                )
              }
            />
          ))}
        </Routes>
      </Suspense>

      <ToastContainer />
    </div>
  );
}

export default App;
